import { splitRelationOrders } from '@/utils/model/Order'
import { findByKeyValue } from '@/utils/array/find'
import { TYPE_INDICATORS } from '@/entities/order/model/const'

export function getRelationOrders (order) {
  const relationOrders = []

  if (order?.relation_orders?.length) {
    order.relation_orders.forEach(order => {
      relationOrders.push(order)
    })
  }

  if (order?.relation_order_text) {
    const accountNumbers = splitRelationOrders(order.relation_order_text)

    for (const accountNumber of accountNumbers) {
      if (findByKeyValue(relationOrders, 'account_number', accountNumber)) continue

      relationOrders.push({
        account_number: accountNumber,
        id: null
      })
    }
  }

  return relationOrders
}

/**
 *
 * Получение установленных индикаторов (позиции и партии заказа) в заказе
 */
export function getIndicatorsOrder (order) {
  const indicators = []
  TYPE_INDICATORS.forEach(indicator => {
    if (order[indicator.name] && order[indicator.name].length) {
      indicators.push({
        ...indicator,
        numbers: order[indicator.name].sort().join(', ') // Отсортировываем по возрастанию и выводим в одну строку
      })
    }
  })

  return indicators
}

/**
 *
 * Получение установленных индикаторов в позиции или партии
 */
export function getCurrentIndicators (item) {
  const indicators = []
  TYPE_INDICATORS.forEach(indicator => {
    if (item[indicator.name]) {
      indicators.push({
        ...indicator
      })
    }
  })

  return indicators
}

/**
 *
 * Получение установленных индикаторов для позиции и её партий
 */
export function getIndicatorsPositionConsignments (position) {
  const indicators = []
  TYPE_INDICATORS.forEach(indicator => {
    if (position[indicator.name]) {
      indicators.push({
        ...indicator
      })
      return
    }

    if (position?.consignments?.length) {
      position.consignments.forEach(consignment => {
        if (consignment[indicator.name] && !indicators.find(item => item.name === indicator.name)) {
          indicators.push({
            ...indicator
          })
        }
      })
    }
  })

  return indicators
}
